<script lang="ts" setup>
import { Popup } from "vant";
import { UnwrapRef } from "vue";
import { useReply } from "@/stores/reply";
import { useRoute } from "vue-router";
import { Reply } from "@/types/entity";
const props = defineProps<{
  show: boolean;
  toVoteReply?: UnwrapRef<Reply> | null;
}>();
const emit = defineEmits<{
  (e: "update:show", show: boolean): void;
}>();
const replyStore = useReply();
const onVote = (emojiId: number) => {
  if (!props.toVoteReply) return;
  const replyId = props.toVoteReply.id!;
  if (!replyStore.getReply(replyId)) {
    replyStore.updateMap([props.toVoteReply]);
  }
  replyStore.vote(emojiId, replyId);
  emit("update:show", false);
};
</script>
<template>
  <popup
    :show="show"
    position="bottom"
    round
    teleport="body"
    @update:show="emit('update:show', $event)"
  >
    <div class="w-full bg-base-100">
      <div class="flex flex-wrap justify-center noto-color-emoji-regular">
        <div
          v-for="emoji in replyStore.emojiList"
          :key="emoji.id"
          class="w-12 h-12 flex items-center justify-center cursor-pointer"
        >
          <div class="text-2xl" @click="onVote(emoji.id)">
            {{ emoji.content }}
          </div>
        </div>
      </div>
    </div>
  </popup>
</template>
